/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 *
 * @export
 * @interface CreateRevision
 */
export interface CreateRevision {
  /**
   * Create an empty revision
   */
  empty?: boolean;
  /**
   * An optional revision number (only superusers can modify)
   */
  number?: number;
  /**
   * An optional creation datetime (only superusers can modify)
   */
  created?: Date;
  /**
   * tags provided as a list of strings
   */
  tags?: Array<string>;
}

/**
 * Check if a given object implements the CreateRevision interface.
 */
export function instanceOfCreateRevision(value: object): value is CreateRevision {
  return true;
}

export function CreateRevisionFromJSON(json: any): CreateRevision {
  return CreateRevisionFromJSONTyped(json, false);
}

export function CreateRevisionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateRevision {
  if (json == null) {
    return json;
  }
  return {
    empty: json["empty"] == null ? undefined : json["empty"],
    number: json["number"] == null ? undefined : json["number"],
    created: json["created"] == null ? undefined : parseDateTime(json["created"]),
    tags: json["tags"] == null ? undefined : json["tags"],
  };
}

export function CreateRevisionToJSON(json: any): CreateRevision {
  return CreateRevisionToJSONTyped(json, false);
}

export function CreateRevisionToJSONTyped(
  value?: CreateRevision | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    empty: value["empty"],
    number: value["number"],
    created: value["created"] == null ? value["created"] : serializeDateTime(value["created"]),
    tags: value["tags"],
  };
}
